module.exports = __webpack_public_path__ + "9a8040fe3822db46f0570c276d35194d.pdf";